import React from "react";
import { Download, Calendar } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourRecoveryJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="start-your-recovery-journey" ref={ref} className={`relative w-full py-24 overflow-hidden transition-opacity duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
      {}
      <div className="absolute inset-0 -z-10 bg-[linear-gradient(135deg,var(--color-accent)_0%,var(--color-background)_100%)] opacity-80" />
      <div className="absolute inset-0 -z-10 shadow-[inset_0_0_100px_rgba(255,255,255,0.8)] pointer-events-none" />
      
      {}
      <div className="absolute inset-4 border border-accent/50 rounded-3xl pointer-events-none opacity-50" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-foreground tracking-tight">
            Start Your Recovery Journey
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Take the next step with a partner who values clarity, compliance, and your personal goals.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border-primary/20 text-primary hover:bg-primary/5 hover:text-primary hover:border-primary/40 bg-transparent h-12 px-8 text-base shadow-sm">
              <Link to="/ReferralsPage">Referal Form</Link>
            </Button>

            <Button asChild size="lg" className="w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-8 text-base shadow-md">
              <Link to="/ContactPage">Make an Enquiry</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}